// extracted by mini-css-extract-plugin
export default {"post":"Post_post__MnBnN","content":"Post_content__pvlq3","linkPost":"Post_linkPost__bXHpf","linkAuthor":"Post_linkAuthor__WiiwX","delete":"Post_delete__ZoNlD"};